//import 'react-app-polyfill/ie11';
//import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import moment from 'moment-timezone';
import initializeI18nPromise from 'localization/i18n';
import store from 'store';
import { ES_TIMEZONE } from 'cpes-common';
import WatchPromise from 'localization/WatchPromise';

const renderApp = (): void => {
    /* eslint-disable @typescript-eslint/no-var-requires */
    const App = require('./App').default;
    /* eslint-enable @typescript-eslint/no-var-requires */
    render(
        <Provider store={store}>
            <WatchPromise promise={initializeI18nPromise}>
                <App />
            </WatchPromise>
        </Provider>,
        document.getElementById('root'),
    );
};

moment.tz.setDefault(ES_TIMEZONE);
renderApp();

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./App', renderApp);
}
